import React from "react";
import Navbar from "../components/Navbar";

export default function ConsentPage() {
  return (
    <main className="min-h-screen" style={{ background: "#080605" }}>
      <Navbar />

      <div className="container-custom pt-32 pb-24">
        <div className="max-w-3xl mx-auto">
          {/* Back link top */}
          <a
            href="/#entradas"
            className="font-sans text-xs tracking-[0.2em] uppercase text-[#E57324] hover:text-[#F08A46] transition-colors inline-block mb-8"
          >
            ← Вернуться на главную
          </a>

          {/* Title */}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#F2E9DE] mb-2">
            СОГЛАСИЕ НА ОБРАБОТКУ <br />
            ПЕРСОНАЛЬНЫХ ДАННЫХ
          </h1>

          <p className="font-sans text-sm text-[#A99F96] mb-12">
            Дата публикации: 05.05.2026
          </p>

          {/* Divider */}
          <div className="w-full h-px mb-12" style={{ background: "rgba(242, 233, 222, 0.1)" }} />

          {/* Content */}
          <div className="space-y-6 font-sans text-base lg:text-lg font-light leading-relaxed tracking-wide text-[#F2E9DE]">
            <p className="mb-6">
              Я, посетитель сайта veronika-valova.ru (далее — Субъект персональных данных), действуя свободно, своей волей и в своем интересе, в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» предоставляю настоящее Согласие на обработку моих персональных данных на следующих условиях:
            </p>

            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                1. Оператор персональных данных
              </h2>
              <p className="mb-3">
                Самозанятая Валова Вероника Сергеевна
                <br />
                ИНН 550726323381
                <br />
                E-mail: verona_piano@mail.ru
              </p>
              <p className="mb-3">
                (далее — Оператор).
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                2. Цели обработки персональных данных
              </h2>
              <p className="mb-3">
                Настоящее Согласие дается на обработку персональных данных для следующих целей:
              </p>

              <div className="mb-4">
                <p className="mb-2 font-medium text-[#F2E9DE]">
                  Цель 1. Обработка запросов, оставленных через форму обратной связи на Сайте, и предоставление ответа на них.
                </p>
                <p className="mb-1">• Категории обрабатываемых данных:</p>
                <p className="mb-1 ml-4">◦ Имя (фамилия, имя, отчество — если указаны);</p>
                <p className="mb-1 ml-4">◦ Номер телефона;</p>
                <p className="mb-1 ml-4">◦ Адрес электронной почты.</p>
              </div>

              <div className="mb-4">
                <p className="mb-2 font-medium text-[#F2E9DE]">
                  Цель 2. Анализ посещаемости и улучшение работы Сайта с использованием сервиса веб-аналитики Яндекс.Метрика.
                </p>
                <p className="mb-1">• Категории обрабатываемых данных (обезличенные, собираемые автоматически):</p>
                <p className="mb-1 ml-4">◦ IP-адрес;</p>
                <p className="mb-1 ml-4">◦ Тип и версия браузера;</p>
                <p className="mb-1 ml-4">◦ Тип и версия операционной системы;</p>
                <p className="mb-1 ml-4">◦ Файлы cookie;</p>
                <p className="mb-1 ml-4">◦ Сведения о посещённых страницах и действиях на Сайте.</p>
              </div>
            </section>

            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                3. Перечень действий с персональными данными
              </h2>
              <p className="mb-3">
                Оператор вправе осуществлять: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, обезличивание, блокирование, удаление и уничтожение персональных данных. Обработка ведётся как с использованием средств автоматизации, так и без них.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                4. Передача данных третьим лицам
              </h2>
              <p className="mb-3">
                Для достижения цели анализа посещаемости обезличенные данные, собираемые автоматически, могут передаваться ООО «ЯНДЕКС» (ИНН 7736207543, ОГРН 1027700229193, адрес: 119021, г. Москва, ул. Льва Толстого, д. 16) — оператору сервиса Яндекс.Метрика в объёме, необходимом для проведения статистического анализа.
              </p>
              <p className="mb-3">
                Трансграничная передача персональных данных не осуществляется.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                5. Срок действия согласия и порядок отзыва
              </h2>
              <p className="mb-3">
                Настоящее согласие действует в течение 1 (одного) года с момента его предоставления, если иное не предусмотрено законодательством.
              </p>
              <p className="mb-3">
                Субъект персональных данных вправе в любой момент отозвать настоящее согласие, направив письменное уведомление на электронную почту Оператора verona_piano@mail.ru.
              </p>
              <p className="mb-3">
                В случае отзыва согласия Оператор прекращает обработку персональных данных и уничтожает их в срок, не превышающий 30 (тридцати) календарных дней с даты получения отзыва.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl sm:text-3xl font-light tracking-tight text-[#F2E9DE] mb-4">
                6. Порядок предоставления согласия в электронной форме
              </h2>
              <p className="mb-3">
                Настоящее Согласие признаётся предоставленным в электронной форме с момента проставления Субъектом персональных данных отметки в чекбоксе «Я прочитал(а) Согласие на обработку персональных данных и подтверждаю его» и нажатия кнопки «Отправить» в форме обратной связи на Сайте.
              </p>
              <p className="mb-3">
                Факт предоставления согласия фиксируется Оператором в электронном журнале учёта с сохранением следующих сведений:
              </p>
              <p className="mb-1 ml-4">• идентификатор согласия (IP-адрес);</p>
              <p className="mb-1 ml-4">• дата и время предоставления согласия;</p>
              <p className="mb-1 ml-4">• содержание предоставленного согласия (текст настоящего документа).</p>
            </section>
          </div>

          {/* Bottom divider */}
          <div className="w-full h-px mt-16 mb-8" style={{ background: "rgba(242, 233, 222, 0.1)" }} />

          <a
            href="/#entradas"
            className="font-sans text-xs tracking-[0.2em] uppercase text-[#E57324] hover:text-[#F08A46] transition-colors"
          >
            ← Вернуться на главную
          </a>
        </div>
      </div>
    </main>
  );
}
